export default __webpack_public_path__ + "static/4-b793ae42880b3ffe3c1260b9a817994c.gif";